var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"l-captcha",attrs:{"data-site-key":"dfa24eee8d556648f5051751d7c10c91","data-width":"100%","data-callback":"getResponse"}}),_c('div',{staticClass:"chongzhi",on:{"click":_vm.chongzhi}},[_vm._v("重新验证")])])}
var staticRenderFns = []

export { render, staticRenderFns }